import { FormikProvider, useFormik } from 'formik';
import { nanoid } from 'nanoid';
import React, { useCallback } from 'react';

import { ContentType } from '@candu-ai/content/types';
import { ContentPlacement } from '@candu-ai/placement/types';

import { SelectorForm } from './components/SelectorForm';
import { validationSchemas } from './validationSchemas';

export interface PlacementProps {
  exists?: boolean;
  editing?: boolean;
  placement: ContentPlacement;
  onSave: (values: any) => Promise<void>;
  onDelete?: () => void;
  setEditing?: () => void;
}

export const Placement = ({ placement, exists, onSave, setEditing }: PlacementProps) => {
  const formik = useFormik<ContentPlacement>({
    initialValues: placement,
    validationSchema: validationSchemas[placement.type || ContentType.Inline],
    onSubmit: async (values: ContentPlacement, { resetForm }) => {
      await onSave(exists ? values : { ...values, id: nanoid(6) });
      resetForm();
    },
  });

  const onCancel = useCallback(() => {
    formik.resetForm({ values: placement });
    if (setEditing) {
      setEditing();
    }
  }, [formik, placement, setEditing]);

  return (
    <FormikProvider value={formik}>
      <SelectorForm exists={exists} onCancel={onCancel} />
    </FormikProvider>
  );
};
